export default __webpack_public_path__ + "static/media/t-notif.5ff94540.svg";